module.exports = __webpack_public_path__ + "img/pathway.0049053e.png";